/** * * Asynchronously loads the component for
HowVLEMobileWorks
* */ import { lazyLoad } from "utils/loadable";
export const HowVLEMobileWorks = lazyLoad(
  () => import("./index"),
  (module) => module.HowVLEMobileWorks
);
